import {
  Gift,
  RefreshCw,
  TicketPercent,
  MessageSquare,
  ClipboardList,
  CheckCircle2,
} from "lucide-react";

function CouponsStats({ coupons }) {
  const totalRedemptions = coupons.length
    ? coupons.reduce((sum, c) => sum + c.redemptions, 0)
    : 0;

  const totalCoupons = coupons.length;

  // Filtered totals
  const surveyCoupons = coupons.filter((c) => c.type === "survey").length || 5;
  const feedbackCoupons =
    coupons.filter((c) => c.type === "feedback").length || 7;

  // Dummy active coupon names
  const activeSurveyCoupons = "General coupon";
  const activeFeedbackCoupons = "Beta Feedback Reward";

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* Total Redemptions */}
      <div className="p-6 bg-gradient-to-r from-purple-600 to-purple-800 text-white rounded-2xl shadow-lg flex items-center space-x-4 hover:scale-[1.02] transition">
        <Gift className="w-10 h-10 opacity-80" />
        <div>
          <p className="text-sm opacity-75">Total Redemptions</p>
          <p className="text-3xl font-bold">{totalRedemptions}</p>
        </div>
      </div>

      {/* New Redemptions */}
      <div className="p-6 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white rounded-2xl shadow-lg flex items-center space-x-4 hover:scale-[1.02] transition">
        <RefreshCw className="w-10 h-10 opacity-80" />
        <div>
          <p className="text-sm opacity-75">New Redemptions</p>
          <p className="text-3xl font-bold">{totalRedemptions}</p>
        </div>
      </div>

      {/* Total Coupons */}
      <div className="p-6 bg-gradient-to-r from-blue-600 to-blue-800 text-white rounded-2xl shadow-lg flex items-center space-x-4 hover:scale-[1.02] transition">
        <TicketPercent className="w-10 h-10 opacity-80" />
        <div>
          <p className="text-sm opacity-75">Total Coupons</p>
          <p className="text-3xl font-bold">{totalCoupons}</p>
        </div>
      </div>

      {/* <div className="p-6 bg-gradient-to-r from-green-500 to-green-700 text-white rounded-2xl shadow-lg flex items-center space-x-4 hover:scale-[1.02] transition">
        <ClipboardList className="w-10 h-10 opacity-80" />
        <div>
          <p className="text-sm opacity-75">Survey / Feedback Coupons</p>
          <p className="text-lg font-semibold">Survey: {surveyCoupons}</p>
          <p className="text-lg font-semibold">Feedback: {feedbackCoupons}</p>
        </div>
      </div>

      <div className="p-6 bg-gradient-to-r from-pink-500 to-pink-700 text-white rounded-2xl shadow-lg hover:scale-[1.02] transition">
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0">
            <MessageSquare className="w-10 h-10 opacity-80 mt-1" />
          </div>
          <div className="flex-1">
            <p className="text-sm opacity-75 font-medium mb-2">
              Active Survey Coupons
            </p>
            <ul className="space-y-1 text-sm max-h-32 overflow-y-auto pr-2">
              {activeSurveyCoupons}
            </ul>
          </div>
        </div>
      </div>

      <div className="p-6 bg-gradient-to-r from-indigo-500 to-indigo-700 text-white rounded-2xl shadow-lg hover:scale-[1.02] transition">
        <div className="flex items-center gap-4">
          <div className="flex-shrink-0">
            <CheckCircle2 className="w-10 h-10 opacity-80 mt-1" />
          </div>
          <div className="flex-1">
            <p className="text-sm opacity-75 font-medium mb-2">
              Active Feedback Coupons
            </p>
            <ul className="space-y-1 text-sm max-h-32 overflow-y-auto pr-2">
              {activeFeedbackCoupons}
            </ul>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default CouponsStats;
